import apiClient from '../utilities/apiClient.utility';

const messageUrl = `${window.config.CONNECT_URLS.messages}`;

export const resendMessage = async ({ program_id, payload }) => {
    return await apiClient.post(
      `${messageUrl}/${program_id}/dashboard/resend-message`,
      payload
    );
};

export const getLatestMessageByCodeAndPatientId = async ({ program_id, customer_id, code }) => {
  return await apiClient.get(
    `${messageUrl}/${program_id}/private/${customer_id}/message-logs/latest?code=${code}`
  );
};
